import React from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Box, Button, Text } from '@/theme/index';

interface ReactivateHeaderProps {
  handleLogout: () => void;
}

export function ReactivateHeader({ handleLogout }: ReactivateHeaderProps) {
  const {
    data: { supportPhone },
  } = useAppConstantsContext();

  return (
    <div>
      <Box sx={{ display: 'inline-block', marginRight: 3, marginTop: '5px' }}>
        <Text sx={{ fontSize: '12px', left: '-10px', position: 'relative' }}>
          Need help? Call us
        </Text>
        <Text sx={{ fontWeight: 'bold', fontSize: '12px' }}>
          {supportPhone}
        </Text>
      </Box>
      <Button
        variant="contained"
        color="success"
        sx={{ width: '140px', transform: 'translateY(25px)' }}
        onClick={handleLogout}
      >
        Logout
      </Button>
    </div>
  );
}
